import React, { useEffect, useState } from "react";
import { Result, Row, Col } from "antd";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import  mail_icon  from "../../../../Assets/paymentIcon/mail_icon.png";
import rejectedIcon from "../../../../Assets/paymentIcon/rejected.png";
import wentWrong from "../../../../Assets/paymentIcon/ballon-error.png";
import notFound from "../../../../Assets/paymentIcon/404.png";
import appProcessing from "../../../../Assets/paymentIcon/processing.png";
import "./style.css";
import { error_message } from "../../../../Constant";

const StatusInfo = {
    "error": {
        icon: wentWrong,
        title: "Something Went Wrong!",
    },
    "601":{
        icon: rejectedIcon,
        title: "Rejected!",
    },
    "602":{
        icon: appProcessing,
        title: "Under Process!",
    },
    "500":{
        icon: wentWrong,
        title: "Something Went Wrong!"
    },
    "404":{
        icon: notFound,
        title: "Oops, Page Not Found!",
    }
}
const ErrorResult = ({
 show = false,
 status = "error",
 errorPathType = ""
}) => {
const [showContactInfo, setShowContactInfo] = useState(false);
useEffect(() => {
  if (status?.errorCode === "602" || status?.errorCode === "500") {
    setShowContactInfo(true);
  }
 else{
     setShowContactInfo(false);
 }
},[status])
  return (
    show && (
      <Result
        icon={<img src={StatusInfo[status?.errorCode]?.icon} />}
        status={"error"}
        title={StatusInfo[status?.errorCode]?.title}
        className={`renew-custom-error error-${status?.errorCode}`}
        subTitle={status?.errorMessage || error_message?.common_error}
        extra={(showContactInfo ? [
          <a href={"tel:18001024462"} style={{ marginRight: "10px" }}>
            <span style={{ fontSize: "14px" }}>
              <FontAwesomeIcon icon={faPhone} color="#f26221" />
              <span style={{ color: "black", marginLeft: "10px" }}>
                {"1800 102 4462"}
              </span>
            </span>
          </a>,
          <a
            href={"mailto:customercare@manipalcigna.com"}
            style={{ marginLeft: "10px" }}
          >
            <span style={{ fontSize: "14px" }}>
              <img
                src={mail_icon}
                style={{
                  width: "24px",
                  height: "18px",
                  display: "inline",
                }}
              />
              <span style={{ color: "black", marginLeft: "10px" }}>
                {"customercare@manipalcigna.com"}
              </span>
            </span>
          </a>,
        ] : [])}
      />
    )
  );
};

export default ErrorResult;
